const skillsLogos = {
    qatouch: require('./qatouch.png'),
    testiny: require('./Testiny.png'),
    testlodge: require('./TestLodge.png'),
    testrail: require('./TestRail.png'),
    zephyr: require('./Zephyr.png'),

    airtable: require('./airtable.png'),
    asana: require('./asana.png'),
    basecamp: require('./basecamp.png'),
    confluence: require('./confluence.png'),
    craft: require('./craft.png'),
    hubspot: require('./hubspot.png'),
    jira: require('./jira.png'),
    jiraServiceDesk: require('./serviceDesk.png'),
    trello: require('./trello.png'),
    notion: require('./notion.png'),
    zenkit: require('./zenkit.png'),

    chai: require('./chai.png'),
    cypress: require('./cypress.jpeg'),
    espresso: require('./espresso.png'),
    ginkgo: require('./ginkgo.png'),
    gomega: require('./gomega.png'),
    mocha: require('./mocha.png'),
    playwright: require('./playwright.png'),
    pytest: require('./pytest.png'),
    rspec: require('./rspec.png'),
    selenium: require('./selenium.png'),
    xcuitest: require('./xcuitest.png'),
    percy: require('./percy.svg'),

    charles: require('./charles.png'),
    fiddler: require('./fiddler.png'),
    insomnia: require('./insomnia.png'),
    postman: require('./postman.png'),
    proxyman: require('./proxyman.jpeg'),
    soapui: require('./soapui.png'),
    swagger: require('./swagger.png'),

    bitrise: require('./bitrise.png'),
    circleci: require('./circleci.png'),
    docker: require('./docker.png'),
    fastlane: require('./fastlane.png'),
    github: require('./github.jpeg'),
    gitlab: require('./gitlab.png'),
    jenkins: require('./jenkins.png'),

    amplitude: require('./amplitude.png'),
    datadog: require('./datadog.png'),
    grafana: require('./grafana.png'),
    mixpanel: require('./mixpanel.png'),
    newRelic: require('./newRelic.png'),
    sentry: require('./Sentry.png'),
    splunk: require('./splunk.png'),

    go: require('./go.png'),
    javascript: require('./javascript.png'),
    mongodb: require('./mongodb.png'),
    mySQL: require('./mysql.png'),
    postgreSQL: require('./postgre.png'),
    python: require('./python.png'),
    ruby: require('./ruby.png'),

    discord: require('./discord.png'),
    googleChat: require('./googleChat.png'),
    googleMeet: require('./googleMeet.png'),
    goToMeeting: require('./GoToMeeting.png'),
    mattermost: require('./mattermost.png'),
    rocketChat: require('./rocketChat.png'),
    slack: require('./slack.png'),
    teams: require('./teams.png'),
    webex: require('./webex.png'),
    zoom: require('./zoom.png')
}

module.exports = skillsLogos
